import { Link } from "react-router-dom";
import type { VideoItem } from "@/types/video";
import { formatViews } from "@/utils/format";

interface PopularListProps {
  videos: VideoItem[];
}

export default function PopularList({ videos }: PopularListProps) {
  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2 md:gap-4">
      {videos.map((video, index) => (
        <Link
          key={video.id}
          to={`/detail/${video.id}`}
          className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
        >
          <span
            className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
              index < 3 ? "bg-accent-500 text-white" : "bg-background-200 text-foreground-600"
            }`}
          >
            {index + 1}
          </span>
          <div className="relative h-14 w-24 shrink-0 overflow-hidden rounded-md bg-background-200">
            <img
              src={video.cover}
              alt={video.title}
              title={`${video.title} 热门视频资源`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <div className="min-w-0 flex-1">
            <h3 className="line-clamp-1 font-heading text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
              {video.title}
            </h3>
            <p className="mt-1 line-clamp-1 text-xs text-foreground-500">{video.summary}</p>
            <div className="mt-1 flex items-center gap-3 text-xs text-foreground-500">
              <span className="flex items-center gap-1">
                <i className="ri-fire-line text-accent-500"></i>
                {formatViews(video.views)}
              </span>
              <span>{video.quality}</span>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}